// extracted by mini-css-extract-plugin
export default {"pageFrame":"AuthorizationStep_pageFrame__h76g9","title":"AuthorizationStep_title__ntOpN","text":"AuthorizationStep_text__+el5o","submit":"AuthorizationStep_submit__DVvDP"};